import { Binder,IBinding,BinderPropertyDescriptor,IConverter } from "./binding/binding";
import { HtmlBridge } from "./parser/bridges/htmlBridge";
import { View } from "./uiPatterns/mvvm/view";
import { ViewModel, ViewModelMessage } from "./uiPatterns/mvvm/viewmodel";
import { BindingConverterResolver } from "./parser/prototype/bindingPrototype";
import { ViewGenerator } from "./parser/viewGenerator";
import { ObservableArray,ObservableArrayChangeListenner,DelegatedObservableArrayChangeListenner } from "./observableList";
import { ComponentTagMappings } from "./parser/bridges/bridgeTypes/compoent";
import { AttachedPropertyValue, Component, ComponentView } from "./uiPatterns/component";
import { SamePropertyNamesBinder } from "./parser/bridges/utilities";

class BinderConfigurator{
    public pushConverterRepository(repo:object){
        BindingConverterResolver.converterRepository.push(repo);
    }
}

export {ComponentTagMappings}
export {Binder,IBinding,BinderPropertyDescriptor,IConverter}
export {View,ViewModel,HtmlBridge}
export {BinderConfigurator}
export {ViewGenerator,ViewModelMessage,SamePropertyNamesBinder}
export {ObservableArray,ObservableArrayChangeListenner,DelegatedObservableArrayChangeListenner}
export {AttachedPropertyValue,Component,ComponentView}